<template>
    <div class="wrapper">
        <div class="banner-preview">
            <img v-if="this.promoActive()" :src="require(`@/assets/images/brands_banner/${this.brand}.png`)"
                 alt="brand banner" class="responsive big-image">
            <img v-if="this.promoActive()" :src="require(`@/assets/images/brands_banner/${this.brand}_mobile.png`)"
                 alt="brand banner" class="responsive mobile-image">
        </div>
    </div>
</template>

<script>
    export default {
        name: "brand-banner",
        props: {
            brand: {
                required: true,
                type: String
            }
        },
        computed: {
            getPromos() {
                return {
                    'jamie_young': {
                        start: new Date(2019, 10, 17, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 4, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'four_hands': {
                        start: new Date(2019, 10, 26, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 8, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'moes': {
                        start: new Date(2019, 10, 21, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 7, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'hooker': {
                        start: new Date(2019, 10, 20, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 9, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'nuevo': {
                        start: new Date(2019, 10, 20, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 3, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'surya': {
                        start: new Date(2019, 10, 17, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 9, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'scout_&_nimble': {
                        start: new Date(2019, 10, 17, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 10, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'mitzi': {
                        start: new Date(2019, 10, 20, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 10, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'hudson_valley_lighting': {
                        start: new Date(2019, 10, 20, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 10, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    },
                    'loloi': {
                        start: new Date(2019, 10, 26, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}),
                        end: new Date(2019, 11, 3, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                    }
                }
            }
        },
        methods: {
            promoActive() {
                let brand = this.brand
                let currentDate = new Date().toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                
                if (!!this.getPromos[brand] && currentDate >= this.getPromos[brand].start && currentDate <= this.getPromos[brand].end) {
                    return true
                }
                return false
            },

        },
    }
</script>

<style lang="scss" scoped>

    .wrapper {
        padding-top: 20px;
        padding-bottom: 20px;
        display: grid;

        .banner-preview {
            position: relative;
            margin: 0 auto;

            img {
                width: 100%;
                max-height: 300px;
            }

            .mobile-image {
                display: none;
            }

            .big-image {
                display: block;
            }

            @media only screen and (max-width: 768px) {
                .mobile-image {
                    display: block;
                }

                .big-image {
                    display: none;
                }
            }
        }
    }
</style>